<div class="relative" (mouseover)="showTargetLink=targetUrl?true:false" (mouseleave)="showTargetLink=false">
    <bakelor-map *ngIf="containerId && canRenderMap" [containerId]="containerId" [style.height.px]="height" [layers]="layers" [center]="target" [zoom]="zoom"
        [minZoom]="5" [maxZoom]="26" [enableFullScreen]="false" [zoomSnap]="0.3" class="reset" (mapReady)="onMapReady($event)">
    </bakelor-map>
    <div *ngIf="showTargetLink" class="absolute bottom-2 right-2 left-2" style="z-index: 99999;">
        <a [href]="targetUrl" target="_blank"
            class="inline-flex w-full justify-center items-center p-5 text-base font-medium text-gray-500 bg-gray-50 rounded-lg hover:text-gray-900 hover:bg-gray-100 ">
            <fa-icon class="mr-3 w-5 h-5" [icon]="['fal','map-location']" ></fa-icon>
            <span class="w-full">Go to LiveView</span>
            <fa-icon class="ml-3 w-6 h-6" [icon]="['fal','arrow-right']"></fa-icon>
        </a>
    </div>
</div>
